/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, IconButton } from '@material-ui/core';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Services';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types'
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useTheme } from '@mui/material/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

var screenCode = "PRICEAPPROVALREPORT"

export default function PriceApprovalReport() {
    const componentRef = useRef();
    const navigate = useNavigate();
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Price Approval Report'
    });
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('cropForecastdate');
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [marketNamesArray, setMarketNameArray] = useState([]);
    const [headCells, SetHeadCells] = useState([]);
    const [datevalue, setDateValue] = useState(new Date());
    const [groupList, setGroupList] = useState([]);
    const [productPrices, setProductPrices] = useState([]);
    const [formData, setFormData] = useState({
        groupID: '',
        productID: ''
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        date: '',

    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [page, setPage] = React.useState(0);
    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    const priceApprovalReportSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            date: datevalue,
        },

        validationSchema: priceApprovalReportSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
        }
    });

    const isFutureDateDisabled = (date) => {
        return date > new Date();
    };

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    useEffect(() => {
        setPage(0);
        getPermissions();
    }, [])

    useEffect(() => {
        GetAllGroups();
    }, []);

    useEffect(() => {
        setProductPrices([]);
    }, [datevalue]);


    const classes = useStyles();

    function EnhancedTableHead(props) {
        const { order, orderBy, onRequestSort } = props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };
        return (
            <TableHead>
                <TableRow>
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align}
                            padding={headCell.disablePadding ? 'none' : 'default'}
                            colSpan={headCell.colSpan || 1}
                            rowSpan={headCell.rowSpan || 1}
                            sortDirection={orderBy === headCell.id ? order : false}
                            sx={{ border: '1px solid black' }}
                            style={{
                                border: "1px solid black",
                                fontWeight: 'bold',
                                ...headCell.style
                            }}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <span className={useStyles.visuallyHidden}>
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
                <TableRow>
                    {headCells.map((headCell) =>
                        headCell.id === 'cargillsPrices' ? (
                            <React.Fragment key={headCell.id}>
                                <TableCell align="right" style={{ border: "1px solid black", fontWeight: 'bold' }}>Buying Price</TableCell>
                                <TableCell align="right" style={{ border: "1px solid black", fontWeight: 'bold' }}>Selling Price</TableCell>
                            </React.Fragment>
                        ) : null
                    )}
                </TableRow>
            </TableHead>
        )
    }

    EnhancedTableHead.propTypes = {
        classes: PropTypes.object.isRequired,
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.oneOf(['asc', 'desc']).isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWPRICEAPPROVALREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        })
        trackPromise(GetAllGroups());
    }

    async function GetAllGroups() {
        let res = await services.GetAllGroups();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function SubmitForm() {

        SetHeadCells([]);
        setPage(0);
        let newRes = await services.GetPriceApprovalReportDetails(
            formik.values.groupID,
            new Date(datevalue).toISOString().split('T')[0]
        );
        setOrder('asc');
        setOrderBy('cropForecastdate');
        var result = [];
        var resultOne = [];
        var headCellsOne = [];
        newRes.forEach(y => {
            y.details.forEach(x => {
                var market = x.market;

                var duplicateDate = result.find(y => y.sku === x.sku);
                if (duplicateDate) {
                    duplicateDate[market] = duplicateDate[market] == undefined ? 0 + x.marketPrice : duplicateDate[factory] + x.marketPrice;
                    duplicateDate.sku = x.sku;
                    duplicateDate.buyingPrice = x.buyingPrice;
                    duplicateDate.sellingPrice = x.sellingPrice;
                    duplicateDate.competitorPrice = x.competitorPrice;
                    duplicateDate.proposedPrice = duplicateDate.proposedPrice;
                }
                else {
                    result.push({
                        [market]: x.marketPrice,
                        sku: x.sku,
                        buyingPrice: x.buyingPrice,
                        sellingPrice: x.sellingPrice,
                        competitorPrice: x.competitorPrice,
                        proposedPrice: x.proposedPrice,
                    });
                }
            });
        });

        newRes.forEach(y => {
            y.details.forEach(x => {
                var duplicateDate = resultOne.find(y => y.market === x.market);
                if (duplicateDate) {
                    duplicateDate.market = x.market
                }
                else {
                    resultOne.push({
                        market: x.market,
                    });
                }
            });
        });
        resultOne.sort((a, b) => a.market > b.market ? 1 : -1);
        headCellsOne.push({
            id: 'sku',
            numeric: false,
            disablePadding: false,
            label: 'SKU',
            align: "center",
            colSpan: 1,
            rowSpan: 2
        },
            {
                id: 'cargillsPrices',
                numeric: true,
                disablePadding: false,
                label: 'Cargills Prices',
                align: "center",
                colSpan: 2
            },
            {
                id: 'proposedPrice',
                numeric: true,
                disablePadding: false,
                label: 'Proposed Prices [Next Date]',
                align: "right",
                colSpan: 1,
                rowSpan: 2
            },
            {
                id: 'competitorPrice',
                numeric: true,
                disablePadding: false,
                label: 'Competitor Price',
                align: "right",
                colSpan: 1,
                rowSpan: 2
            })

        resultOne.forEach(x => {
            headCellsOne.push({
                id: x.market,
                numeric: true,
                disablePadding: false,
                label: x.market + " Selling Price",
                align: "right",
                colSpan: 1,
                rowSpan: 2
            })
        })

        setMarketNameArray(resultOne);
        setProductPrices(result);
        SetHeadCells(headCellsOne)
        createDataForExcel(result);
        getSelectedDropdownValuesForReport();
    }

    async function clearAll() {
        if (!permissionList.isFactoryFilterEnabled) {
            setDateValue(new Date());
            setProductPrices([]);
        } else {
            setDateValue(new Date());
            setProductPrices([]);
        }
    }

    function getSelectedDropdownValuesForReport() {

        let groups = groupList.find(x => x.groupID == formik.values.groupID)
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            date: new Date(datevalue).toISOString().split('T')[0]
        });
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.forEach(x => { });
        }
        return res;
    }

    async function createFile() {
        var file = await createDataForExcel(productPrices);

        var settings = {
            sheetName: 'Price Approval Report',
            fileName: 'Price Approval Report',
            writeOptions: {}
        };

        let headCellsTwo = [];

        headCellsTwo.push({ label: 'SKU', value: 'sku' },
            { label: 'Cargills Buying Price ', value: 'buyingPrice' },
            { label: 'Cargills Selling Price', value: 'sellingPrice' },
            { label: 'Proposed Price', value: 'proposedPrice' },
            { label: 'Competitor Price', value: 'competitorPrice' }
        );

        marketNamesArray.forEach(x => {
            const label = x.market;
            const value = x.market == undefined ? ' - ' : x.market;
            headCellsTwo.push({ label, value });
        });

        const formattedCropAvailability = productPrices.map(item => {
            let formattedItem = {
                ...item,
                buyingPrice: item.buyingPrice ? parseFloat(item.buyingPrice).toFixed(2) : '-',
                sellingPrice: item.sellingPrice ? parseFloat(item.sellingPrice).toFixed(2) : '-',
                proposedPrice: item.proposedPrice ? parseFloat(item.proposedPrice).toFixed(2) : '-',
                competitorPrice: item.competitorPrice ? parseFloat(item.competitorPrice).toFixed(2) : '-',
            };

            marketNamesArray.forEach(column => {
                const value = item[column.market];
                formattedItem[column.market] = value === undefined || value == 0 ? '-' : parseFloat(value).toFixed(2);
            });

            return formattedItem;
        });

        // Add total row
        let totalRow = {
            sku: 'Total',
            buyingPrice: productPrices.reduce((acc, curr) => acc + (curr.buyingPrice || 0), 0).toFixed(2),
            sellingPrice: productPrices.reduce((acc, curr) => acc + (curr.sellingPrice || 0), 0).toFixed(2),
            proposedPrice: productPrices.reduce((acc, curr) => acc + (curr.proposedPrice || 0), 0).toFixed(2),
            competitorPrice: productPrices.reduce((acc, curr) => acc + (curr.competitorPrice || 0), 0).toFixed(2),
        };

        marketNamesArray.forEach(column => {
            totalRow[column.market] = productPrices.reduce((acc, curr) => acc + (curr[column.market] || 0), 0).toFixed(2);
        });

        formattedCropAvailability.push(totalRow);

        let dataA = [
            {
                sheet: 'Price Approval Report',
                columns: headCellsTwo,
                content: formattedCropAvailability
            }
        ];
        xlsx(dataA, settings);
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Price Approval Report  |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Group *"
                                            value={formik.values.groupID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('groupID')}
                                            error={Boolean(touched.groupID && errors.groupID)}
                                            helperText={touched.groupID && errors.groupID}
                                            InputProps={{
                                                readOnly: !permissionList.isGroupFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}>Select Group</MenuItem>
                                            {groupList.map((option) => (
                                                option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                    {option.groupName}
                                                </MenuItem> : null
                                            ))}
                                        </TextField>

                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                fullWidth
                                                label="Date *"
                                                openTo="day"
                                                type="date"
                                                inputFormat="MM/DD/YYYY"
                                                value={datevalue}
                                                onChange={(newValue) => {
                                                    setDateValue(newValue);
                                                }}
                                                shouldDisableDate={isFutureDateDisabled}
                                                renderInput={(params) =>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...params}
                                                    />}
                                            />
                                        </LocalizationProvider>
                                    </Stack>

                                    <div>
                                        <br />
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button type="button" variant="outlined" color="error"
                                                onClick={() => clearAll()}
                                            >
                                                Clear
                                            </Button>
                                            <Button type="submit" color="secondary" variant="outlined"
                                            >
                                                Search
                                            </Button>
                                        </Stack>
                                    </div>
                                </Stack>
                            </Stack>
                            <>
                                <br />
                                {productPrices.length != 0 ? (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                                <TableContainer >
                                                    <Table
                                                        aria-labelledby="tableTitle"
                                                        aria-label="enhanced table"
                                                    >
                                                        <EnhancedTableHead
                                                            classes={classes}
                                                            order={order}
                                                            orderBy={orderBy}
                                                            onRequestSort={handleRequestSort}
                                                            rowCount={productPrices.length}
                                                        />
                                                        <TableBody>
                                                            {stableSort(productPrices, getComparator(order, orderBy))
                                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                .map((market, index) => {
                                                                    const labelId = `enhanced-table-checkbox-${index}`;
                                                                    return (
                                                                        <TableRow key={index} >
                                                                            <TableCell component="th" id={labelId} scope="row" align='center' sx={{ border: '1px solid black' }}>
                                                                                {market.sku}
                                                                            </TableCell>
                                                                            <TableCell component="th" id={labelId} scope="row" align='center' sx={{ border: '1px solid black' }}>
                                                                                {market.buyingPrice > 0 ? parseFloat(market.buyingPrice).toFixed(2) : '-'}
                                                                            </TableCell>
                                                                            <TableCell component="th" id={labelId} scope="row" align='center' sx={{ border: '1px solid black' }}>
                                                                                {market.sellingPrice > 0 ? parseFloat(market.sellingPrice).toFixed(2) : '-'}
                                                                            </TableCell>
                                                                            <TableCell component="th" id={labelId} scope="row" align='right' sx={{ border: '1px solid black' }}>
                                                                                {market.proposedPrice > 0 ? parseFloat(market.proposedPrice).toFixed(2) : '-'}
                                                                            </TableCell>
                                                                            <TableCell component="th" id={labelId} scope="row" align='right' sx={{ border: '1px solid black' }}>
                                                                                {market.competitorPrice > 0 ? parseFloat(market.competitorPrice).toFixed(2) : '-'}
                                                                            </TableCell>
                                                                            {marketNamesArray.map((column) => {
                                                                                const value = market[column.market];
                                                                                return (
                                                                                    <TableCell id={labelId} scope="row" align={column.tableCellAlign == 1 ? 'right' : column.tableCellAlign == 2 ? 'right' : 'right'} sx={{ border: '1px solid black' }}>
                                                                                        {value == undefined ? '-' : column.numeric == true ? parseFloat(value).toFixed(2) : parseFloat(value).toFixed(2)}
                                                                                    </TableCell>
                                                                                );
                                                                            })}
                                                                        </TableRow>
                                                                    );
                                                                })}
                                                                <TableRow>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                                                        Total
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                                                    {productPrices.reduce((acc, curr) => acc + (curr.buyingPrice || 0), 0).toFixed(2)}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                                                        {productPrices.reduce((acc, curr) => acc + (curr.sellingPrice || 0), 0).toFixed(2)}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                                                        {productPrices.reduce((acc, curr) => acc + (curr.proposedPrice || 0), 0).toFixed(2)}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                                                        {productPrices.reduce((acc, curr) => acc + (curr.competitorPrice || 0), 0).toFixed(2)}
                                                                    </TableCell>
                                                                    {marketNamesArray.map((column, colIndex) => (
                                                                        <TableCell key={colIndex} scope="row" align="right" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                                                                            {productPrices.reduce((acc, curr) => acc + (curr[column.market] || 0), 0).toFixed(2)}
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                    component="div"
                                                    count={productPrices.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                />
                                            </Card>
                                        </Stack>
                                    </>
                                ) : <SearchNotFound searchQuery="Price Approval Report" />}</>
                        </Form>
                    </FormikProvider>
                    {productPrices.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <div>&nbsp;</div>
                            <style>
                                {`
                                 @page  {
                                            size: A4 landscape; 
                                            margin: 20mm;
                                        }
                               `}
                            </style>
                            <ReactToPrint
                                documentTitle={"Price Approval Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    productList={productPrices}
                                    searchData={selectedSearchValues}
                                    marketNamesArray={marketNamesArray}
                                    EnhancedTableHead={EnhancedTableHead}
                                    order={order}
                                    orderBy={orderBy}
                                    handleRequestSort={handleRequestSort}
                                    onRequestSort={handleRequestSort}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page >
        </>
    );
}
